import {Text} from "pixi.js";
import {Vector} from "../i.js"; // ../vector.js
import {UIUtils} from "../i.js"; // ../ui/utils.js
import {Button} from "../i.js"; // ./button.js
import {Tab} from "../i.js"; // ./tab.js
import {ACHIEVEMENTS} from "../i.js";

export class Forge extends Tab {
	// Create a new technology forge
	// Each unicenter should create exactly one technology forge.
	//
	// Args:
	//   unicenter - reference to the unicenter
	//   savefile  - optional savefile (object)
	constructor(unicenter, savefile) {
		super(unicenter,
			new Set(["Forge Station"]),
			Tab.LOCATIONS.LEFT,
			"images/icons/upgrader.svg",
			0,
			"Technology Forge"
		);

		this.thrustersForged = savefile?.tf ?? false;

		// Visuals

		this.display.title = new Text(
			"Technology Forge",
			UIUtils.getFont(this.colorHighlight)
		);

		this.display.forgeButton = new Button(unicenter);

		this.display.addChild(this.display.title, this.display.forgeButton);
	}

	// Update the forge
	// Call this every tick. visible is a boolean that is true if the display is
	// visible this tick. size is a vector in pixels representing the desired
	// size of the display.
	update(visible, size) {
		if (visible) {
			if (this.display.forgeButton.wasClicked()
							&& this.unicenter.inventory.hasStar()) {
				this.thrustersForged = true;
				this.unicenter.ship.achievements.recordAchievement(
					ACHIEVEMENTS.THRUSTERS
				);
			}
		}

		super.update(visible, size);

		this.display.forgeButton.clearStuff();
	}

	save() {
		return {
			tf: this.thrustersForged
		};
	}

	// Check whether the player can currently upgrade / forge anything
	anythingToDo() {
		// Can forge thrusters, that's something to do!
		if (!this.thrustersForged && this.unicenter.inventory.hasStar()) {
			return true;
		}

		// Nothing to do :(
		return false;
	}

	// Refresh the display, redrawing everything from scratch
	// This method only needs to be called when something actually changed, but
	// it's okay to call it every tick.
	_refreshDisplay() {
		let size = this.display.size;
		// let narrowMargin = this.unicenter.requestMarginWidth(1);
		// let wideMargin = this.unicenter.requestMarginWidth(2);

		this.display.title.style.fontSize = this.unicenter.requestFontSize("LARGE");

		let buttonSize = new Vector(size.x, size.y / 3).round();
		let buttonOrigin = Vector.diff(size, buttonSize);
		let forgeText = this.thrustersForged ?
			"Maneuvering thrusters forged, use them with (A)(S)(D)"
							+ " or (\u2b05)(\u2b07)(\u27a1)"
			: "Forge maneuvering thrusters (requires a star)";
		this.display.forgeButton.update(
			this.colorBase,
			this.colorHighlight,
			buttonOrigin,
			buttonSize,
			forgeText
		);
	}
}
